import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExpenseState } from 'types'
import { lastMonth, lastYear } from 'utils/DateUtils'
import { getRole } from 'utils/storage.service'

export const initialState: ExpenseState = {
    loading: false,
    ytdDetails: [],
    headwiseExpenseDetails: [],
    eventWiseExpenseDetails:[],
    reps: [],
    expenseGroups: [],
    filter: {
        year: lastYear,
        month: lastMonth,
        role: getRole(),
        manager: 'ALL',
        rep: 'ALL',
        region: 'ALL',
        territory: 'ALL',
    },
    yoyExpense: [],
    yoyEventExpense:[],
    yoyBudgetExpense: {},
}

const dashboardSlice = createSlice({
    name: 'expense',
    initialState,
    reducers: {
        setYtdDetails: (state, { payload }: PayloadAction<any>) => {
            state.loading = false
            state.ytdDetails = payload || []
        },
        setHeadwiseExpenseDetails: (state, { payload }: PayloadAction<any>) => {
            state.loading = false
            state.headwiseExpenseDetails = payload
        },
        setEventWiseExpenseDetails: (state, { payload }: PayloadAction<any>) => {
            state.loading = false
            state.eventWiseExpenseDetails = payload
        },
        setReps: (state, { payload }: PayloadAction<any>) => {
            state.reps = payload
        },
        setExpenseGroups: (state, { payload }: PayloadAction<any>) => {
            state.expenseGroups = payload
        },
        setYoyExpense: (state, { payload }: PayloadAction<any>) => {
            state.yoyExpense = payload
        },
        setYoyEventExpense: (state, { payload }: PayloadAction<any>) => {
            state.yoyEventExpense = payload
        },
        setYoyBudgetExpense: (state, { payload }: PayloadAction<any>) => {
            state.yoyBudgetExpense = payload
        },
        setFilter: (state, { payload }: PayloadAction<any>) => {
            const filter = { ...payload }

            state.filter = { ...state.filter, ...filter }
        },
    },
})

export const {
    setYtdDetails,
    setHeadwiseExpenseDetails,
    setEventWiseExpenseDetails,
    setExpenseGroups,
    setReps,
    setYoyExpense,
    setYoyEventExpense,
    setYoyBudgetExpense,
    setFilter,
} = dashboardSlice.actions

export default dashboardSlice.reducer
